// extracted by mini-css-extract-plugin
export default {"pic":"UpdateCameraPlaceHolder_pic__w9d+y","outer":"UpdateCameraPlaceHolder_outer__H-Vhf"};